<red-header></red-header>
<ion-content [scrollX]="false" [scrollY]="false">
  <google-map
    height="100%"
    width="100%"
    [center]="(mapCenter$ | async)"
    [options]="(mapOptions$ | async)"
    (mapInitialized)="mapInitialized($event)"
    (mapDragend)="mapDragend()"
  >
    <map-marker [position]="(searchLocation$ | async)" [options]="(markerOptions$ | async)"> </map-marker>
    <red-user-position></red-user-position>
  </google-map>
  <div class="tw:absolute tw:top-0 tw:right-1/2 tw:w-full tw:max-w-2xl tw:translate-x-1/2">
    <red-map-search-property></red-map-search-property>
    <red-map-default-options>
      <red-user-position-center-button></red-user-position-center-button>
    </red-map-default-options>
  </div>
  <div class="tw:absolute tw:right-1/2 tw:bottom-0 tw:w-full tw:max-w-2xl tw:translate-x-1/2">
    @if (searchLocation$ | async) {
    <ion-card color="light">
      <ion-card-header class="tw:pb-0">
        <ion-card-subtitle>Dropped PIN at:</ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <div class="tw:flex tw:justify-between tw:align-middle">
          <div class="tw:pr-1">
            <div class="tw:text-sm">
              <ion-text>{{(searchAddressComponents$ | async) | redAddress:addressType.LineOne}}</ion-text>
            </div>
            <div class="tw:text-xs">
              <ion-text color="medium">
                {{(searchAddressComponents$ | async) | redAddress:addressType.LineTwo}}
              </ion-text>
            </div>
          </div>
          <div class="tw:flex tw:flex-col tw:items-center tw:align-middle">
            <ion-button (click)="loadProfile()" class="tw:whitespace-nowrap" size="small" fill="solid">
              <ion-icon slot="end" name="chevron-forward-circle-outline"></ion-icon>Profile
            </ion-button>
            <ion-button (click)="clearSearch()" class="tw:whitespace-nowrap" size="small" fill="clear" color="danger">
              <ion-icon slot="end" name="close-circle-outline"></ion-icon>Cancel
            </ion-button>
          </div>
        </div>
      </ion-card-content>
    </ion-card>
    }
  </div>
</ion-content>
